#import "../fragments/visitor-iq-filter-settings-fragment.graphql"

query GetVisitorIqFilterSettings {
    visitorIqFilterSettings {
        ...VisitorIqFilterSettingsFragment
    }
}
